import { render, staticRenderFns } from "./cryptoWithdrawal.vue?vue&type=template&id=52238f04"
import script from "./cryptoWithdrawal.vue?vue&type=script&lang=js"
export * from "./cryptoWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./cryptoWithdrawal.vue?vue&type=style&index=0&id=52238f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports